<template>
  <div class="content home-page ai-ppt-detail">
    <Header></Header>
    <div class="chances-top disflex crfff ac">
      <div @click="back">
        <img width="20" src="../../static/images/back.png" class="nav-icon-left" />
        <div>{{$t('Back')}}</div>
      </div>
    </div>

    <div class="info crfff ac">
      <div class="fs40 mt50 mb30">{{ description }}</div>

      <!-- PPT 预览区域 -->
      <div class="ppt-preview-container mt30">
        <iframe
          v-if="url"
          :src="'https://view.officeapps.live.com/op/view.aspx?src=' + encodeURIComponent(url)"
          width="100%"
          height="500px"
          frameborder="0"
        ></iframe>
        <div v-else class="no-preview">
          <img width="80" src="../../static/images/index/index_cate_aidoc.png" />
          <p class="mt20">{{ $t('NoPreviewAvailable') }}</p>
        </div>
      </div>

      <!-- 操作按钮区域 -->
      <div class="tools-section mt50">
        <div class="input-item mb30">
          <div class="input-item2">
            <input class="input" v-model="url" disabled type="text">
          </div>
        </div>

        <div class="flex-buttons">
          <button class="button fw7 flex1" id="copyLink" :data-clipboard-text="url" @click="copy">
            <img width="18" src="../../static/images/copy1.png" style="margin-right: 10px;"/>
            {{ $t('copyLink') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '../components/Header'
import Clipboard from 'clipboard'

export default {
  components: {
    Header
  },
  data() {
    return {
      url: '',
      description: '',
      format: ''
    }
  },
  created() {
    // 从路由参数中获取数据
    this.url = this.$route.query.url || ''
    this.description = this.$route.query.description || 'AI PPT'
    this.format = this.$route.query.format || 'ppt'
  },
  methods: {
    back() {
      this.$router.go(-1)
    },
    downloadFile() {
      if (!this.url) return
      window.open(this.url, '_blank')
    },
    copy() {
      const clipboard = new Clipboard('#copyLink')
      clipboard.on('success', (e) => {
        this.$utils.alertText(this.$t('CopySucceeded'))
        clipboard.destroy()
      })
      clipboard.on('error', (e) => {
        clipboard.destroy()
      })
    }
  }
}
</script>

<style scoped>
.ai-ppt-detail {
  padding-bottom: 0.5rem;
}
.ppt-preview-container {
  width: 94%;
  margin: 0 auto;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 0.2rem;
  overflow: hidden;
  min-height: 400px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.no-preview {
  text-align: center;
  color: #999;
}
.tools-section {
  width: 94%;
  margin: 0 auto;
}
.flex-buttons {
  display: flex;
  gap: 0.2rem;
}
.flex1 {
  flex: 1;
}
.mr20 {
  margin-right: 0.2rem;
}
.mb30 {
  margin-bottom: 0.3rem;
}
.fs40 {
  font-size: 0.4rem;
}
</style>



// WEBPACK FOOTER //
// src/page/aiPpt_detail.vue